<div class="relative">
  <button mat-icon-button mat-dialog-close color="primary" aria-label="Close icon"
          class="absolute top-0 right-0 scale-125">
    <mat-icon>close</mat-icon>
  </button>
</div>

<img alt="Add blacklist item icon" src="../../../assets/figures/add-item.svg" class="h-[88px] mb-6 mx-auto"/>
<span mat-dialog-title class="text-3xl font-bold text-center">Felhasználó hozzáadása a feketelistához</span>
<form [formGroup]="addBlacklistItemFormGroup" (ngSubmit)="onSubmit()" class="flex flex-col justify-between">
  <div class="flex justify-between items-center gap-x-6 px-4">
    <mat-form-field appearance="standard" class="basis-0 grow" hideRequiredMarker>
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" autocomplete="email">
      <mat-error *ngIf="addBlacklistItemFormGroup.get('email')?.hasError('email')">
        Az email cím formátuma nem megfelelő
      </mat-error>
      <mat-error *ngIf="addBlacklistItemFormGroup.get('email')?.hasError('required')">
        Kötelező mező
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard" class="basis-0 grow" hideRequiredMarker>
      <mat-label>Telefonszám</mat-label>
      <input matInput formControlName="phoneNumber" type="tel" autocomplete="tel-national">
      <mat-error *ngIf="addBlacklistItemFormGroup.get('phoneNumber')?.hasError('pattern')">
        A telefonszám formátuma nem megfelelő
      </mat-error>
      <mat-error *ngIf="addBlacklistItemFormGroup.get('phoneNumber')?.hasError('required')">
        Kötelező mező
      </mat-error>
    </mat-form-field>
  </div>

  <div class="flex justify-between items-center gap-x-6 px-4">
    <mat-form-field appearance="standard" class="basis-0 grow" hideRequiredMarker>
      <mat-label>Jogosítvány szám</mat-label>
      <input matInput formControlName="licenseNumber" autocomplete="on">
      <mat-error *ngIf="addBlacklistItemFormGroup.get('licenseNumber')?.hasError('required')">
        Kötelező mező
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard" class="basis-0 grow" hideRequiredMarker>
      <mat-label>Születési dátum</mat-label>
      <input matInput formControlName="birthDate" [max]="birthDateMax" [matDatepicker]="birthDatePicker" autocomplete="bday">
      <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #birthDatePicker></mat-datepicker>
      <mat-error *ngIf="addBlacklistItemFormGroup.get('birthDate')?.hasError('matDatepickerParse')">
        A dátum formátuma nem megfelelő
      </mat-error>
      <mat-error *ngIf="addBlacklistItemFormGroup.get('birthDate')?.hasError('required')">
        Kötelező mező
      </mat-error>
    </mat-form-field>
  </div>

  <div class="flex justify-between items-center gap-x-6 px-4">
    <mat-form-field appearance="standard" class="basis-0 grow" [class.warning]="submitAttemptedWithEmptyAddressCardNumber && addressCardNumberIsEmpty" hideRequiredMarker>
      <mat-label>Lakcímkártya szám</mat-label>
      <input id="address-card-number" matInput formControlName="addressCardNumber" autocomplete="address-card-number">
      <mat-hint *ngIf="submitAttemptedWithEmptyAddressCardNumber && addressCardNumberIsEmpty">Biztosan üresen hagyod?</mat-hint>
      <mat-error *ngIf="addBlacklistItemFormGroup.get('addressCardNumber')?.hasError('addressCard')">
        A lakcímkártya szám 6 számból és 2 betűből kell álljon
      </mat-error>
    </mat-form-field>
    <div class="empty-placeholder"></div>
  </div>

  <mat-form-field appearance="standard" class="grow px-4 mb-6" hideRequiredMarker>
    <mat-label>Indoklás</mat-label>
    <input matInput formControlName="reason" autocomplete="off">
    <mat-error *ngIf="addBlacklistItemFormGroup.get('reason')?.hasError('required')">
      Kötelező mező
    </mat-error>
  </mat-form-field>

  <p class="font-light text-center">Feketelistára kerülés dátuma:</p>
  <p class="font-bold text-center mb-6">{{formattedCreationDate()}}</p>

  <div mat-dialog-actions class="flex justify-between gap-x-4 p-0 mb-0">
    <button mat-stroked-button mat-dialog-close color="primary" type="button" class="mol-btn-lg mol-btn-stroked-primary basis-0 grow">Mégsem</button>
    <button mat-flat-button color="primary" type="submit" class="mol-btn-lg basis-0 grow ml-0">Hozzáadás</button>
  </div>

</form>
